import React from 'react';
import PropTypes from 'prop-types';

const Buttons = props => (
  <section className="module-filter top">
    <div className="general-help"><div>
      {props.language.summary.ffdSleep[props.reportType].generalHelp}
    </div></div>
    <div className="flex">
      <div className="flex filter-box table-filter">
        <h2 id={`select-filter-group`} className="container-filter-h2">
          <span>{props.language.filter.reportGroup + " "}</span>
          {props.selectGroup==1 ? props.language.filter.workShiftGroup :
            props.language.filter[props.selectGroup.toLowerCase()]}
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li no-padding">
            <i className="fas fa-caret-down" />
            <ul data-nonescroll="ok">
              {props.group.map((value, e) => (
                <li key={e}>
                  <a
                    role="button"
                    tabIndex={0}
                    data-select={value}
                    data-category={"Tag"}
                    data-parent={`select-filter-group`}
                    onClick={props.handleSubmit}
                  >
                    {props.language.filter[value.toLowerCase()]}
                  </a>
                </li>
              ))}
              <li>
                <a
                  role="button"
                  tabIndex={0}
                  data-select={"1"}
                  data-category={"WorkingShiftGroup"}
                  data-parent={`select-filter-group`}
                  onClick={props.handleSubmit}
                >
                  {props.language.filter.workShiftGroup}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="excel-buttons">
        <div className="box-form">
          <ul className="buttom_menu">
            <li>
              {props.language.summary.ffdSleep.downloadExcel}
              <ul>
                <li>
                  <a data-close="ok" onClick={props.handleDownloadExcelSummary}>
                    {props.language.summary.ffdSleep.downloadSummaryExcel}
                  </a>
                </li>
                <li>
                  <a data-close="ok" onClick={props.handleDownloadExcelNoProcess}>
                    {props.language.summary.ffdSleep.downloadNoProcessExcel}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_sleep/buttons.jsx